import { API } from "@/lib/auth";

export const photoUrl = (p) => (!p ? null : p.startsWith("/") || p.startsWith("http") ? p : `${API}/files/${p}`);

const LOCALES = { en: "en-GB", de: "de-DE", fr: "fr-FR" };

export const fmtKm = (n, lang) => `${new Intl.NumberFormat(LOCALES[lang]).format(n)} km`;

export const vehicleTitle = (v) => `${v.make} ${v.model}`;

export const FUELS = ["petrol", "diesel", "hybrid", "plug_in_hybrid", "electric", "lpg"];
export const BODIES = ["city_car", "hatchback", "sedan", "suv", "crossover", "estate", "lcv", "other"];
export const TRANSMISSIONS = ["manual", "automatic"];
